import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { SM_BREAKPOINT } from '../../../../breakpoints'

export default function Tab ({ name, active, onPress }) {

  let Element = active ? ContainerActive : Container

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    }
  }

  return (
    
    <Element active onClick={onPress} activeOpacity={1} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} >
      <motion.div variants={itemVariants} initial="hidden" animate="visible">
        <Name
          color={active ? '#19A0FA' : '#D0D0D0'}
          ellipsizeMode="tail"
          numberOfLines={2}
        >
          {name}
        </Name>
      </motion.div>
    </Element>
  )
}

const Container = styled(motion.button)`
  display: flex;
  background-color: #fff;
  min-width: 100px;
  margin: 12px 10px 12px 0;
  border-radius: 10px;
  justify-content: center;
  align-items: stretch;
  padding: 12px;
  max-width: 250px;
  flex: 1;

  @media screen and (max-width: ${SM_BREAKPOINT}em) {
    max-width: 100%;
    margin: 12px 0;
  }
`

const ContainerActive = styled(Container)`
  box-shadow: 0 4px 5px rgba(41, 76, 143, 0.19);
  elevation: 5px;
  background-color: #ffffff;
`

const Name = styled.p`
  color: ${props => props.color};
  font-weight: 800;
  text-align: center;
`
